var Theme;
(function (Theme) {
  Theme["MicroFocus"] = "micro-focus";
  Theme["MicroFocusDark"] = "micro-focus-dark";
  Theme["WhiteLabel"] = "white-label";
  Theme["OpenText"] = "opentext";
  Theme["OpenTextStage1"] = "opentext-stage-1";
  Theme["OpenTextStage1Dark"] = "opentext-stage-1-dark";
  Theme["JatoLight"] = "jato-light";
  Theme["JatoDark"] = "jato-dark";
})(Theme || (Theme = {}));
export { Theme };